import { Outlet } from "react-router-dom";
import LanguageSelector from "./language-selector/LanguageSelector";
import LateralMenu from "./lateral-menu/LateralMenu";
import { useUserStore } from "@/store/useUser";
import { APP_VERSION } from "@/lib/version";

const Layout = () => {
  const { isSupervisor } = useUserStore();

  if (isSupervisor) {
    return (
      <div className="grid grid-cols-[auto_1fr] h-full min-h-0 max-w-full">
        <LateralMenu />
        <section className="grid grid-rows-[auto_1fr] h-full min-h-0 max-w-full bg-white">
          <LanguageSelector />
          <Outlet />
        </section>
      </div>
    );
  }

  return (
    <section className="grid grid-rows-[auto_1fr] h-full min-h-0 max-w-full bg-white">
      <LanguageSelector />
      <Outlet />
      <div className="absolute bottom-0 left-2 md:pb-4  text-xs text-gray-300">
        {APP_VERSION}
      </div>
    </section>
  );
};

export default Layout;
